export default __webpack_public_path__ + "static/media/music-licensing.71cf08b1.svg";